import "./app/register-extensions";
import "./styles/index.scss";
import "@neu/libui/libui.css";

import { NeuAppRender } from "@neu/libui";

import { Bootstrap } from "./app/bootstrap";

NeuAppRender({ appName: "HCA Application", appPath: "/" }, <Bootstrap />);
